import { Box, Flex, Page } from '@revolut-internal/ui-kit'

import { NotFoundWidget } from 'components/NotFoundWidget'

export const NotFound = () => (
  <Page>
    <Page.Main size="full">
      <Flex alignItems="center" justifyContent="center" height="100%">
        <Box width={520}>
          <NotFoundWidget description="Page not found" />
        </Box>
      </Flex>
    </Page.Main>
  </Page>
)
